import styled from 'styled-components';
import { GUTTER } from '../../../utilities/grid';
import { media } from '../../../utilities/media';
export const RowWrapper = styled.div `
  display: flex;
  flex: 1 1 1;
  flex-direction: column;

  & > *:not(:first-child) {
    margin: ${GUTTER.mobile}px 0 0 0;
  }

  ${media.tablet `
    ${({ mode, gutter, alignment }) => {
    if (mode === 'grid') {
        let justifyContent = 'center';
        if (alignment === 'left') {
            justifyContent = 'flex-start';
        }
        else if (alignment === 'right') {
            justifyContent = 'flex-end';
        }
        return `
          flex-direction: row;
          align-items: flex-start;
          justify-content: ${justifyContent};

          & > *:not(:first-child) {
            margin: 0;
          }

          margin-left: -${Number(gutter) / 2}px;
          margin-right: -${Number(gutter) / 2}px;

          & > * {
            padding: 0 ${Number(gutter) / 2}px;
          }
        `;
    }
    else {
        let alignItems = 'flex-start';
        if (alignment === 'right') {
            alignItems = 'flex-end';
        }
        else if (alignment === 'center') {
            alignItems = 'center';
        }
        return `
          flex-direction: column;
          align-items: ${alignItems};
          & > *:not(:first-child) {
            margin: ${gutter}px 0 0 0;
          }
        `;
    }
}}
  `};
`;
//# sourceMappingURL=RowWrapper.js.map